const sortTranscripts = (a: [string, unknown], b: [string, unknown]) =>
  parseInt(a[0].substr(1)) - parseInt(b[0].substr(1));

export default sortTranscripts;
